import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Custom hook for automatic page view tracking in React Router
 * Tracks route changes and sends page_view events to GA4
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page title from route or document
    const pageTitle = getPageTitle(location.pathname);
    
    // Track page view
    trackPageView(location.pathname, pageTitle);
  }, [location]);
};

/**
 * Map routes to readable page titles
 */
const getPageTitle = (pathname: string): string => {
  const routes: Record<string, string> = {
    '/': 'Home',
    '/categories': 'Categories',
    '/products': 'All Products',
    '/cart': 'Shopping Cart',
    '/checkout': 'Checkout',
    '/orders': 'My Orders',
    '/profile': 'Profile',
    '/wishlist': 'Wishlist',
    '/addresses': 'Manage Addresses',
    '/add-address': 'Add Address',
    '/support': 'Support',
    '/bulk-orders': 'Bulk Orders',
    '/privacy-policy': 'Privacy Policy',
    '/terms-of-service': 'Terms of Service',
    '/refund-policy': 'Refund Policy',
    '/login': 'Login'
  };

  // Check for exact match
  if (routes[pathname]) {
    return routes[pathname];
  }

  // Check for dynamic routes
  if (pathname.startsWith('/category/')) {
    return 'Category Products';
  }
  if (pathname.startsWith('/product/')) {
    return 'Product Detail';
  }
  if (pathname.startsWith('/order/')) {
    return 'Order Detail';
  }
  if (pathname.startsWith('/order-confirmation/')) {
    return 'Order Confirmation';
  }

  return 'Shetkari Agro Fresh';
};

export default usePageTracking;
